import React, { useState } from "react";
import { Star, ChevronLeft, ChevronRight, Quote } from "lucide-react";

const Testimonials = () => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const testimonials = [
    {
      id: 1,
      name: "Michael Chen",
      role: "General Contractor",
      company: "Chen Construction Ltd.",
      location: "Vancouver, BC",
      rating: 5,
      text: "Timberlake Flooring has been our go-to supplier for over 3 years. Their engineered hardwood quality is unmatched, and the factory-direct pricing allows us to stay competitive on every project. Highly recommend for any contractor.",
      image: "https://randomuser.me/api/portraits/men/32.jpg"
    },
    {
      id: 2,
      name: "Sarah Thompson",
      role: "Interior Designer",
      company: "Thompson Interiors",
      location: "Richmond, BC",
      rating: 5,
      text: "The Grand Estate Collection transformed my client's 5,000 sq ft home into a masterpiece. The wide-plank hardwood adds such elegance. Timberlake's team was professional and delivery was right on schedule.",
      image: "https://randomuser.me/api/portraits/women/44.jpg"
    },
    {
      id: 3,
      name: "David Rodriguez",
      role: "Custom Home Builder",
      company: "Westcoast Premium Homes",
      location: "West Vancouver, BC",
      rating: 5,
      text: "We exclusively use Timberlake for our luxury home builds. Their NatureSense engineered hardwood performs beautifully in our high-end projects. The quality speaks for itself - our clients are always impressed.",
      image: "https://randomuser.me/api/portraits/men/67.jpg"
    },
    {
      id: 4,
      name: "Jennifer Walsh",
      role: "Homeowner",
      company: "",
      location: "Burnaby, BC",
      rating: 5,
      text: "After getting quotes from 5 different companies, Timberlake offered the best value without compromising on quality. Our new hardwood floors are absolutely stunning. The installation team was courteous and efficient.",
      image: "https://randomuser.me/api/portraits/women/68.jpg"
    },
    {
      id: 5,
      name: "Robert Kim",
      role: "Property Developer",
      company: "Pacific Rim Developments",
      location: "Surrey, BC",
      rating: 5,
      text: "We've completed 12 multi-unit projects with Timberlake flooring. Consistent quality, competitive bulk pricing, and reliable delivery every time. They understand the needs of large-scale developments.",
      image: "https://randomuser.me/api/portraits/men/52.jpg"
    },
    {
      id: 6,
      name: "Amanda Foster",
      role: "Renovation Specialist",
      company: "Foster Home Renovations",
      location: "Coquitlam, BC",
      rating: 5,
      text: "The ComfortSense laminate collection is perfect for my renovation clients - water-resistant, durable, and looks like real hardwood. Timberlake's product knowledge helped me choose the right flooring for each space.",
      image: "https://randomuser.me/api/portraits/women/33.jpg"
    },
    {
      id: 7,
      name: "James Patterson",
      role: "Commercial Contractor",
      company: "Patterson Commercial Build",
      location: "New Westminster, BC",
      rating: 5,
      text: "For our office and retail projects, Timberlake's SolidSense vinyl flooring is unbeatable. High traffic durability with premium aesthetics. Their commercial team understands tight deadlines and delivers.",
      image: "https://randomuser.me/api/portraits/men/45.jpg"
    },
    {
      id: 8,
      name: "Lisa Nguyen",
      role: "Homeowner",
      company: "",
      location: "Port Moody, BC",
      rating: 5,
      text: "We renovated our entire main floor with Timberlake's engineered hardwood. The transformation is incredible! From quote to installation, the experience was seamless. Worth every penny.",
      image: "https://randomuser.me/api/portraits/women/55.jpg"
    },
    {
      id: 9,
      name: "Mark Stevens",
      role: "Architect",
      company: "Stevens Architecture Group",
      location: "Vancouver, BC",
      rating: 5,
      text: "I specify Timberlake flooring for my residential designs because of their premium quality and extensive selection. The wide-format planks create the grand aesthetic my clients desire.",
      image: "https://randomuser.me/api/portraits/men/22.jpg"
    },
    {
      id: 10,
      name: "Rachel Morrison",
      role: "Real Estate Investor",
      company: "Morrison Properties",
      location: "Langley, BC",
      rating: 5,
      text: "Timberlake flooring has increased the value of every property I've renovated. Buyers notice quality floors immediately. The ROI on their products is exceptional for investment properties.",
      image: "https://randomuser.me/api/portraits/women/28.jpg"
    },
    {
      id: 11,
      name: "Kevin O'Brien",
      role: "Flooring Installer",
      company: "O'Brien Flooring Services",
      location: "Maple Ridge, BC",
      rating: 5,
      text: "As an installer, I appreciate Timberlake's consistent product quality. Their engineered hardwood is a pleasure to work with - precise dimensions, excellent click-lock systems, and minimal waste.",
      image: "https://randomuser.me/api/portraits/men/36.jpg"
    },
    {
      id: 12,
      name: "Diana Cruz",
      role: "Homeowner",
      company: "",
      location: "North Vancouver, BC",
      rating: 5,
      text: "The team at Timberlake helped us choose the perfect flooring for our waterfront home. The moisture-resistant engineered hardwood performs beautifully even with our humidity levels. Exceptional service!",
      image: "https://randomuser.me/api/portraits/women/42.jpg"
    },
    {
      id: 13,
      name: "Andrew Campbell",
      role: "Project Manager",
      company: "Campbell & Sons Construction",
      location: "Abbotsford, BC",
      rating: 5,
      text: "Timberlake's pricing transparency and product quality make budgeting easy for our clients. No hidden costs, no surprises. Just premium flooring delivered professionally every time.",
      image: "https://randomuser.me/api/portraits/men/58.jpg"
    },
    {
      id: 14,
      name: "Michelle Lee",
      role: "Stager & Designer",
      company: "Lee Home Staging",
      location: "Richmond, BC",
      rating: 5,
      text: "Beautiful floors sell homes faster. I recommend Timberlake to all my clients preparing to sell. The visual impact of their hardwood flooring photographs beautifully and impresses buyers.",
      image: "https://randomuser.me/api/portraits/women/63.jpg"
    },
    {
      id: 15,
      name: "Thomas Wright",
      role: "Custom Cabinet Maker",
      company: "Wright Woodworks",
      location: "Delta, BC",
      rating: 5,
      text: "The wood tones in Timberlake's collections complement my custom cabinetry perfectly. I often coordinate with their team to ensure seamless design integration for our mutual clients.",
      image: "https://randomuser.me/api/portraits/men/41.jpg"
    }
  ];

  const itemsPerView = 3;
  const maxIndex = Math.ceil(testimonials.length / itemsPerView) - 1;

  const nextSlide = () => {
    setCurrentIndex((prev) => (prev >= maxIndex ? 0 : prev + 1));
  };

  const prevSlide = () => {
    setCurrentIndex((prev) => (prev <= 0 ? maxIndex : prev - 1));
  };

  const visibleTestimonials = testimonials.slice(
    currentIndex * itemsPerView,
    currentIndex * itemsPerView + itemsPerView
  );

  return (
    <section className="py-20 bg-gradient-to-b from-white to-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-luxury-navy mb-4 luxury-heading">
            What Our Clients Say
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Trusted by contractors and builders across British Columbia
          </p>
          <div className="w-24 h-1 bg-luxury-gold mx-auto mt-6"></div>
        </div>

        {/* Testimonials Grid */}
        <div className="relative">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {visibleTestimonials.map((testimonial) => (
              <div
                key={testimonial.id}
                className="bg-white rounded-xl shadow-lg p-8 hover:shadow-2xl transition-all duration-300 border border-gray-100 relative"
              >
                {/* Quote Icon */}
                <div className="absolute -top-4 left-8">
                  <div className="bg-luxury-gold p-3 rounded-full">
                    <Quote className="w-5 h-5 text-luxury-navy" />
                  </div>
                </div>

                {/* Rating */}
                <div className="flex gap-1 mb-4 mt-4">
                  {[...Array(testimonial.rating)].map((_, i) => (
                    <Star
                      key={i}
                      className="w-5 h-5 fill-luxury-gold text-luxury-gold"
                    />
                  ))}
                </div>

                {/* Testimonial Text */}
                <p className="text-gray-700 leading-relaxed mb-6 italic">
                  "{testimonial.text}"
                </p>

                {/* Author Info */}
                <div className="flex items-center gap-4 pt-4 border-t border-gray-100">
                  <img
                    src={testimonial.image}
                    alt={testimonial.name}
                    className="w-14 h-14 rounded-full object-cover border-2 border-luxury-gold"
                  />
                  <div>
                    <h4 className="font-semibold text-luxury-navy">
                      {testimonial.name}
                    </h4>
                    <p className="text-sm text-gray-600">
                      {testimonial.role}
                      {testimonial.company && `, ${testimonial.company}`}
                    </p>
                    <p className="text-xs text-luxury-gold">{testimonial.location}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* Navigation Arrows */}
          <button
            onClick={prevSlide}
            className="absolute -left-4 top-1/2 -translate-y-1/2 bg-luxury-navy text-white p-3 rounded-full shadow-lg hover:bg-luxury-gold hover:text-luxury-navy transition-all duration-300 hidden lg:block"
            aria-label="Previous testimonials"
          >
            <ChevronLeft className="w-6 h-6" />
          </button>
          <button
            onClick={nextSlide}
            className="absolute -right-4 top-1/2 -translate-y-1/2 bg-luxury-navy text-white p-3 rounded-full shadow-lg hover:bg-luxury-gold hover:text-luxury-navy transition-all duration-300 hidden lg:block"
            aria-label="Next testimonials"
          >
            <ChevronRight className="w-6 h-6" />
          </button>
        </div>

        {/* Dots Indicator */}
        <div className="flex justify-center gap-2 mt-10">
          {[...Array(maxIndex + 1)].map((_, index) => (
            <button
              key={index}
              onClick={() => setCurrentIndex(index)}
              className={`w-3 h-3 rounded-full transition-all duration-300 ${
                index === currentIndex
                  ? "bg-luxury-gold w-8"
                  : "bg-gray-300 hover:bg-gray-400"
              }`}
              aria-label={`Go to testimonial set ${index + 1}`}
            />
          ))}
        </div>

        {/* Trust Badges */}
        <div className="mt-16 text-center">
          <p className="text-sm text-gray-500 mb-4">Proudly serving</p>
          <div className="flex flex-wrap justify-center gap-6 text-gray-400">
            <span className="px-4 py-2 bg-gray-100 rounded-full text-sm">Vancouver</span>
            <span className="px-4 py-2 bg-gray-100 rounded-full text-sm">Richmond</span>
            <span className="px-4 py-2 bg-gray-100 rounded-full text-sm">Burnaby</span>
            <span className="px-4 py-2 bg-gray-100 rounded-full text-sm">Surrey</span>
            <span className="px-4 py-2 bg-gray-100 rounded-full text-sm">Coquitlam</span>
            <span className="px-4 py-2 bg-gray-100 rounded-full text-sm">+ All of BC</span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
